import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'

// Layout components
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import TrackingHead from './components/TrackingHead'
import SEO from './components/SEO'
import ScrollToTop from './components/ScrollToTop'

// I18n
import I18nProvider from './components/I18nProvider'

// Hooks
import { useAuthStore } from './store/authStore'
import { useThemeStore } from './store/themeStore'

/**
 * App is the root layout shared by every route. Page content is rendered
 * through <Outlet />. Routing itself is defined in src/routes.jsx so that
 * vite-react-ssg can statically pre-render each route at build time.
 */
function App() {
  const { checkAuth } = useAuthStore()
  const { isDark } = useThemeStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <I18nProvider>
      <div className={`min-h-screen flex flex-col transition-colors duration-300 ${isDark ? 'bg-[#111827] text-white' : 'bg-white text-gray-900'}`}>
        <ScrollToTop />
        <TrackingHead />
        {/* Site-wide default SEO. Individual pages override these via their own <SEO /> (react-helmet last-wins). */}
        <SEO
          title="Home"
          description="Convert and process files locally. Support 3900+ formats including video, audio, image, PDF conversion and compression. Fast, free, and secure."
          schema={[
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Joy File Convert",
              "url": "https://joyfileconvert.com/"
            },
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Joy File Convert",
              "url": "https://joyfileconvert.com/"
            }
            // NOTE: SoftwareApplication + aggregateRating lives on the homepage
            // only (see Home.jsx). Emitting a review rating on every tool page
            // is treated by Google as misplaced review snippets.
          ]}
        />

        <Navbar />

        <main className="flex-1">
          <Outlet />
        </main>

        <Footer />

        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </I18nProvider>
  )
}

export default App
